import { useEffect } from 'react'
import { messagesApi } from '../api/messages'
import { useChatStore } from '../stores/chatStore'
import { useScheduledStore } from '../stores/scheduledStore'

export function useScheduledMessages() {
  useEffect(() => {
    const check = async () => {
      const { messages, removeDue } = useScheduledStore.getState()
      const now = Date.now()
      const due = messages.filter((m) => new Date(m.scheduledFor).getTime() <= now)
      if (!due.length) return

      const sent: string[] = []
      await Promise.allSettled(
        due.map(async (m) => {
          try {
            const msg = await messagesApi.send(m.chatId, {
              text: m.text,
              media_ids: m.mediaIds,
              reply_to_message_id: m.replyToId,
            })
            useChatStore.getState().appendMessage(msg)
            sent.push(m.id)
          } catch {
            // Will retry on next tick
          }
        }),
      )
      if (sent.length) removeDue(sent)
    }

    check()
    const timer = setInterval(check, 30_000)
    return () => clearInterval(timer)
  }, [])
}
